module.exports = __webpack_public_path__ + "logo.png?4c573d3fcb51f1e19e777089cf0bb40d";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 5
// module chunks = 0